import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { CouponListTableDataColumnType, CouponListTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import api from "../../../utils/api";
import Swal from "sweetalert2";

export const couponListTableData = [
    {
        coupanId: 2,
        coupanCode: "FLAT40",
        discountAmount: 40,
        expiryDate: "2025-05-31T17:58:10.606"
    },
    {
        coupanId: 3,
        coupanCode: "SUMMER20",
        discountAmount: 20,
        expiryDate: "2025-06-15T12:00:00.000"
    },
];

// const OfferListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.delete(`/api/Coupan/DeleteCoupan?coupanId=${id}`);
    Swal.fire('Deleted!', 'Coupon has been deleted.', 'success');

    // Optional: refresh the list
    // setTicketListTableDatas((prev) => prev.filter((item) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the coupon.', 'error');
    console.error("Delete error:", error);
  }
};

interface ProductListTableActionProps {
  coupanId: any;
  onDelete: (id: number) => void;
}

export const OfferListTableAction: React.FC<ProductListTableActionProps> = ({ coupanId, onDelete }) => {
  const editUrl = `/coupon/edit/${coupanId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this offer!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(coupanId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};


export const CouponListTableOfferComponent: React.FC<CouponListTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const couponListTableStatus :React.FC<CouponListTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const couponListTableDataColumn: TableColumn<CouponListTableDataColumnType>[] = [
  {
    name: "Coupn Code",
    cell: (row) => <CouponListTableOfferComponent title={row.coupanCode}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Discount Amount",
    selector: (row) => `${row.discountAmount}`,
    sortable: true,
  },
  {
    name: "Expiry Date",
    selector: (row) => `${row.expiryDate}`,
    sortable: true,
  },
  {
    name: "Action",
    cell: (row) => <OfferListTableAction coupanId={row.coupanId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Title",
      options: ["Adult", "Child"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];